import { Location } from "@angular/common";
import { Injectable } from "@angular/core";
import { CanActivate, Router, UrlTree } from "@angular/router";
import { ReplaySubject, throwError } from "rxjs";
import { catchError, switchMap, take } from "rxjs/operators";
import { SessionService } from "./services/session.service";

@Injectable()
export class AdminGuard implements CanActivate {

    constructor(
        private _sessionService: SessionService,
        private _router: Router,
        private _location: Location
    ) { }

    canActivate() {
        let subject = new ReplaySubject<boolean | UrlTree>(1);
        this._sessionService.tryLogin().pipe(take(1), catchError((error) => {
            this._router.navigateByUrl(this._router.createUrlTree(['/login'], {
                'queryParams': {
                    'redirect': this._location.path()
                }
            }));
            return throwError(error);
        }), switchMap(() => this._sessionService.hasRight('edit_datasets', false))).subscribe({
            next: (value) => {
                subject.next(value);
            }
        });
        return subject.asObservable();
    }

}